module.exports = __webpack_public_path__ + "static/text6-3cb13583c564996bd2fbd1345d8918ea.svg";